/* TrisoToys — Fiche produit JS — assets/trisotoys-product.js */

function trisotoysSetImage(src,thumbEl){
  var wrapper=document.getElementById("trisotoys-gallery-main");
  var mainImg=document.getElementById("trisotoys-main-image");
  if(!mainImg&&wrapper){
    wrapper.innerHTML='<img id="trisotoys-main-image" src="'+src+'" alt="" class="trisotoys-gallery__featured" style="transition:opacity .15s ease;opacity:1;">';
    document.querySelectorAll(".trisotoys-gallery__thumb").forEach(function(t){t.classList.remove("is-active");});
    if(thumbEl)thumbEl.classList.add("is-active");return;
  }
  if(!mainImg)return;
  mainImg.style.opacity="0";
  setTimeout(function(){mainImg.src=src;mainImg.style.opacity="1";},150);
  document.querySelectorAll(".trisotoys-gallery__thumb").forEach(function(t){t.classList.remove("is-active");});
  if(thumbEl)thumbEl.classList.add("is-active");
}

function trisotoysSetVideo(url,poster,thumbEl){
  var wrapper=document.getElementById("trisotoys-gallery-main");
  if(!wrapper)return;
  wrapper.innerHTML='<video id="trisotoys-main-video" class="trisotoys-gallery__featured" autoplay muted loop playsinline poster="'+poster+'"><source src="'+url+'" type="video/mp4"></video>';
  var v=document.getElementById("trisotoys-main-video");
  if(v){v.muted=true;v.play().catch(function(){});}
  document.querySelectorAll(".trisotoys-gallery__thumb").forEach(function(t){t.classList.remove("is-active");});
  if(thumbEl)thumbEl.classList.add("is-active");
}

function trisotoysInitVideo(){
  var vid=document.getElementById("trisotoys-main-video");
  if(!vid)return;
  vid.muted=true;
  vid.play().catch(function(){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){vid.play().catch(function(){});io.disconnect();}});
    },{threshold:0.1});
    io.observe(vid);
  });
}

function trisotoysQty(delta){
  var inp=document.getElementById("trisotoys-qty");
  if(!inp)return;
  inp.value=Math.max(1,Math.min(99,(parseInt(inp.value,10)||1)+delta));
}

function trisotoysInitVariants(){
  var form=document.querySelector(".trisotoys-form");if(!form)return;
  var dataEl=document.getElementById("trisotoys-product-data");if(!dataEl)return;
  var pd;try{pd=JSON.parse(dataEl.textContent);}catch(e){return;}
  var options=pd.options,variants=pd.variants;
  if(!variants||!variants.length)return;
  function fmt(c){return(parseFloat(c)/100).toLocaleString("fr-FR",{style:"currency",currency:"EUR",minimumFractionDigits:2});}
  function getSV(){
    var sel=options.map(function(o){var r=form.querySelector('input[name="options['+o+']"]:checked');return r?r.value:null;});
    return variants.find(function(v){return sel.every(function(val,i){return !val||v["option"+(i+1)]===val;});})||null;
  }
  function updatePrice(v){
    var row=document.querySelector(".trisotoys-price-row");if(!row)return;
    var p=parseFloat(v.price),ca=v.compare_at_price?parseFloat(v.compare_at_price):0;
    if(ca>p){var s=ca-p;row.innerHTML='<span class="trisotoys-price trisotoys-price--sale">'+fmt(p)+'</span><span class="trisotoys-price trisotoys-price--compare">'+fmt(ca)+'</span><span class="trisotoys-savings-badge">Economisez '+fmt(s)+'</span>';}
    else{row.innerHTML='<span class="trisotoys-price">'+fmt(p)+'</span>';}
  }
  function updateImage(v){
    if(!v.featured_image)return;
    var id=v.featured_image.id,src=v.featured_image.src;
    var resized=src.replace(/(\.[^./?]+(\?.*)?)$/,"_800x$1");
    var thumb=null;
    document.querySelectorAll(".trisotoys-gallery__thumb").forEach(function(t){if(String(t.dataset.imageId)===String(id))thumb=t;});
    trisotoysSetImage(resized,thumb);
  }
  function updateVid(v){var h=form.querySelector('input[name="id"]');if(h)h.value=v.id;}
  function updateAvail(v){
    var btn=form.querySelector('[name="add"]');if(!btn)return;
    btn.disabled=!v.available;btn.textContent=v.available?"Ajouter au panier":"Rupture de stock";
  }
  function onChange(upImg){
    var v=getSV();if(!v)return;
    updateVid(v);updatePrice(v);if(upImg)updateImage(v);updateAvail(v);
  }
  form.querySelectorAll('input[type="radio"]').forEach(function(r){r.addEventListener("change",function(){onChange(true);});});
  onChange(false);
}

function trisotoysInitUpsell(){
  var sec=document.getElementById("trisotoys-upsell");if(!sec)return;
  var pid=sec.dataset.productId;if(!pid)return;
  function fp(c){return(parseFloat(c)/100).toLocaleString("fr-FR",{style:"currency",currency:"EUR",minimumFractionDigits:2});}
  fetch("/recommendations/products.json?product_id="+pid+"&limit=4&intent=related")
    .then(function(r){return r.json();})
    .then(function(d){
      var ps=d.products||[];if(!ps.length){sec.style.display="none";return;}
      var html=ps.map(function(p){
        var i=p.featured_image||"";
        var it=i?'<img src="'+i+'" alt="'+((p.title||"").replace(/"/g,""))+'" loading="lazy" class="trisotoys-upsell-card__img">'
              :'<div class="trisotoys-upsell-card__img trisotoys-upsell-card__img--placeholder"></div>';
        var pr=p.variants&&p.variants[0]?fp(p.variants[0].price):"";
        return '<a href="/products/'+p.handle+'" class="trisotoys-upsell-card">'+it
          +'<div class="trisotoys-upsell-card__body"><p class="trisotoys-upsell-card__title">'+p.title+'</p>'
          +'<p class="trisotoys-upsell-card__price">'+pr+'</p></div></a>';
      }).join("");
      var g=sec.querySelector(".trisotoys-upsell__grid");if(g)g.innerHTML=html;
    }).catch(function(){sec.style.display="none";});
}

document.addEventListener("DOMContentLoaded",function(){
  trisotoysInitVideo();trisotoysInitVariants();trisotoysInitUpsell();
});